export default __webpack_public_path__ + "static/media/checkbox-usage-filter.fe37112a.svg";